export const GET_SEJOURS_PRICES = "sejours/GET_SEJOURS_PRICES";
export const UPDATE_SEJOURS_PRICES = "sejours/UPDATE_SEJOURS_PRICES";
export const DELETE_SEJOURS_PRICES = "sejours/DELETE_SEJOURS_PRICES";